import { fetchStaticData } from './../actions/home-page.actions';
import { ApiUserService } from 'src/app/api/api/api-user/api-user.service';
import { UiFunction } from './../../../../models/data/UI-data.model ';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as HomePageAction from '../actions/home-page.actions'
import * as UserAction from '../../../user/actions/user.actions'
import { RootState } from 'src/app/store/root.reducer';
import { Store } from '@ngrx/store';
import { selectUserAuth } from 'src/app/store/user/selectors/user.selectors';
import { UserAuth } from 'src/app/models/data/user.model';


@Injectable()
export class HomePageEffects {


  constructor(
    private actions$: Actions,
    private store: Store<RootState>,
    private apiUserService:ApiUserService
    ) {
  }

}
